/**
 * Display best scores on the home page under each game card
 */

import { formatBestScore, getBestScore, isGameType } from '../utils/bestScores.js';

function displayHomePageScores() {
  const gameCards = document.querySelectorAll('.game-card.available');

  gameCards.forEach(card => {
    const gameAttr = card.getAttribute('data-game');
    if (!isGameType(gameAttr)) return;

    const gameTitle = card.querySelector('.game-title');
    if (!gameTitle) return;

    // Memory keeps records per level rather than one score.
    if (gameAttr === 'memory-game') {
      import('../games/memory-game/game/records.js').then(({ formatBestResult }) => {
        const best = formatBestResult();
        if (best === null || card.querySelector('.game-best-score')) return;
        const element = document.createElement('div');
        element.className = 'game-best-score';
        element.textContent = `Best: ${best}`;
        gameTitle.insertAdjacentElement('afterend', element);
      });
      return;
    }

    const bestScore = getBestScore(gameAttr);
    if (bestScore === 0) return; // Don't show if no score yet

    // Check if score element already exists
    let scoreElement = card.querySelector('.game-best-score');
    if (!scoreElement) {
      scoreElement = document.createElement('div');
      scoreElement.className = 'game-best-score';
      gameTitle.insertAdjacentElement('afterend', scoreElement);
    }

    // Custom display for different games
    if (gameAttr === 'maze') {
      import('../games/maze/utils/MazeScoreDisplay.js').then(({ formatMazeBestScore }) => {
        const formatted = formatMazeBestScore(gameAttr);
        if (formatted !== '0') {
          scoreElement.textContent = `Highest level: ${formatted}`;
        }
      });
    } else if (gameAttr === 'sort-puzzle') {
      const label = 'Highest level';
      scoreElement.textContent = `${label}: ${formatBestScore(gameAttr)}`;
    } else if (gameAttr === 'quick-math') {
      // Show both highest grade and best score for quick-math
      const bestScore = formatBestScore(gameAttr);
      import('../games/quick-math/game/records.js').then(({ loadHighestGrade }) => {
        const highestGrade = loadHighestGrade();
        if (highestGrade > 0 && bestScore !== '0') {
          scoreElement.textContent = `Grade ${highestGrade} • Best: ${bestScore}`;
        } else if (highestGrade > 0) {
          scoreElement.textContent = `Grade ${highestGrade}`;
        } else if (bestScore !== '0') {
          scoreElement.textContent = `Best: ${bestScore}`;
        }
      });
    } else {
      const label = 'Best';
      scoreElement.textContent = `${label}: ${formatBestScore(gameAttr)}`;
    }
  });
}

// Run when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', displayHomePageScores);
} else {
  displayHomePageScores();
}
